require('./shops/shops.js');
